"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Treeview = void 0;
var React = require("react");
var Keyboard_1 = require("../../_Core/Keyboard");
var Localization_1 = require("../../Localization");
var Styles_1 = require("./Styles");
var _1 = require("./");
var Treeview = function (_a) {
    var Data = _a.Data, FontSize = _a.FontSize, IndentAmount = _a.IndentAmount, OnDataRequest = _a.OnDataRequest, RenderFolder = _a.RenderFolder, RenderItem = _a.RenderItem, RenderNoData = _a.RenderNoData, SelectedItemID = _a.SelectedItemID, SpaceAfterGroup = _a.SpaceAfterGroup, FullWidthFocusStyling = _a.FullWidthFocusStyling;
    var id = 0;
    var recursivelySetInternalKeysAndFolders = function (children, prefix) {
        if (children) {
            for (var i = 0; i < children.length; i++) {
                children[i].InternalKey = (prefix || "") + "_" + id++;
                recursivelySetInternalKeysAndFolders(children[i].Children, children[i].InternalKey);
                children[i].Folder = children[i].Folder || children[i].Children && children[i].Children.length > 0;
            }
        }
    };
    var fixedData = __spreadArray([], Data);
    recursivelySetInternalKeysAndFolders(fixedData);
    var _b = React.useState(fixedData), data = _b[0], setData = _b[1];
    React.useEffect(function () { return setData(Data); }, [Data]);
    var recursivelyUpdateExpand = function (children, internalKey, isExpanded) {
        if (children) {
            for (var i = 0; i < children.length; i++) {
                if (children[i].InternalKey === internalKey) {
                    children[i].IsExpanded = isExpanded;
                    return true;
                }
                if (children[i].Folder && recursivelyUpdateExpand(children[i].Children, internalKey, isExpanded)) {
                    return true;
                }
            }
        }
        return false;
    };
    var onExpandCollapseHandler = function (item, isExpand) {
        var modifiedData = __spreadArray([], data);
        recursivelyUpdateExpand(modifiedData, item.InternalKey, isExpand);
        setData(modifiedData);
    };
    return Data && Data.length > 0 ? (React.createElement(Styles_1.TreeGroup, { role: "tree", FontSize: FontSize, FullWidthFocusStyling: FullWidthFocusStyling },
        React.createElement(_1.TreeviewList, { Data: data, FirstElement: true, OnFocusEvent: handleOnFocusEvent, OnDataRequest: OnDataRequest, RenderFolder: RenderFolder, RenderItem: RenderItem, OnExpandCollapse: onExpandCollapseHandler, OnKeyboardMovementEvent: handleUpDownKeyboardEvents, IndentAmount: IndentAmount, SelectedItemID: SelectedItemID, SpaceAfterGroup: SpaceAfterGroup, FullWidthFocusStyling: FullWidthFocusStyling }))) : RenderNoData ? (React.createElement(RenderNoData, null)) : (React.createElement("p", { role: "alert", "aria-live": "polite" }, Localization_1.strings.Treeview_Message_NoData));
};
exports.Treeview = Treeview;
/**
 * Keep track of the one with focus so we can change the tab index
 * @param e Focus event
 */
var currentFocusElement;
var handleOnFocusEvent = function (e) {
    currentFocusElement = e.target;
    currentFocusElement.tabIndex = 0;
};
var handleUpDownKeyboardEvents = function (e) {
    var _a;
    e.stopPropagation();
    e.preventDefault();
    var target = e.target;
    if (Keyboard_1.IsDownArrow(e)) {
        if (TreeviewFolderIsExpanded(target) && target.children[1].querySelector("li")) {
            (_a = target.children[1].querySelector("li")) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            var nextSibling = TreeviewNextSibling(target);
            if (nextSibling) {
                nextSibling.focus();
            }
        }
    }
    else if (Keyboard_1.IsUpArrow(e)) {
        // go up through the tree
        var prevSib = TreeviewPreviousSibling(target);
        if (prevSib) {
            var focusThisElement = TreeviewFollowDown(prevSib);
            if (focusThisElement) {
                focusThisElement.focus();
            }
        }
        else {
            var parentItem = target.parentElement.closest("li");
            if (parentItem) {
                parentItem.focus();
            }
        }
    }
};
var TreeviewFolderIsExpanded = function (findItem) {
    var expanded = findItem.attributes.getNamedItem("aria-expanded");
    if (expanded) {
        return expanded.value === "true";
    }
    else {
        return false;
    }
};
var TreeviewFollowDown = function (sibling) {
    if (sibling.lastElementChild.nodeName === "UL") {
        if (sibling.lastElementChild.parentElement.getAttribute("aria-expanded") === "true" && sibling.lastElementChild.children.length > 0) {
            return TreeviewFollowDown(sibling.lastElementChild.lastChild);
        }
        else {
            return sibling.lastElementChild.parentElement;
        }
    }
    else {
        return sibling;
    }
};
var TreeviewPreviousSibling = function (findItem) {
    return findItem.previousSibling;
};
var TreeviewNextSibling = function (findItem) {
    if (findItem) {
        // is there anything next in the list?
        var nextSib = findItem.nextElementSibling;
        // if this is null, then we are at the end of the list, so see if we can go in.
        if (!nextSib) {
            if (TreeviewFolderIsExpanded(findItem) && findItem.children[1].querySelector("li")) {
                // to the first child
            }
            else {
                // look up the tree to see if there is anywhere to go
                nextSib = TreeViewLookup(findItem);
            }
        }
        else {
            if (!nextSib && findItem.parentElement) {
                nextSib = TreeviewNextSibling(findItem.parentElement);
            }
        }
        return nextSib;
    }
};
var TreeViewLookup = function (findItem) {
    var parent = findItem.parentElement;
    var found;
    if (parent) {
        if (parent.nodeName === "UL") {
            // go up one more.
            found = TreeViewLookup(parent);
        }
        else if (parent.nodeName === "LI") {
            // test to see if there is another LI to go to
            var next = parent.nextElementSibling;
            found = next || TreeViewLookup(parent.parentElement);
        }
        else {
            return null;
        }
    }
    return found;
};
